<div class="depoimentos-list">
  <unh-generic-swiper-slider
    class="swiper-slide-flex"
    *ngIf="depoimentos.length > 0"
    [items]="depoimentos"
    [isMobile]="false"
    [swiperConfigs]="swiperConfigsDepoimentos"
  >
    <ng-template #genericSwiperItemTemplate let-item>
      <unh-depoimentos-item
        [avatar]="item.avatar"
        [name]="item.name"
        [specialty]="item.specialty"
        [rating]="item.rating"
        [content]="item.content"
      ></unh-depoimentos-item>
    </ng-template>
  </unh-generic-swiper-slider>
</div>
